import React from 'react';
import Carousel from '../molecules/Carousel/Carousel';
import useWindowSize from '../components/useWindowSize';

const FestivalCarousel = ({carousel, homeMounted}) => {
  const {Title, Url, Items, ColorBand, ColorLetter} = carousel;
  const [width] = useWindowSize();
  return carousel && Items && Items.length !== 0 ? <Carousel
    title={Title}
    listingUrl={Url}
    products={Items}
    isFestival={true}
    showLoading={false}
    backColor={ColorBand}
    fontColor={ColorLetter}
    homeMounted={homeMounted}
    width={width}
  /> : '';
};

export default FestivalCarousel;
